module.exports = __webpack_public_path__ + "static/media/mail1.78ba4825.svg";